/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface TeacherLoadRow
 */
export interface TeacherLoadRow {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof TeacherLoadRow
     */
    teacherId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof TeacherLoadRow
     */
    teacherName: string;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof TeacherLoadRow
     */
    classesCount: ApiUserTasksGetPageParameter;
}

/**
 * Check if a given object implements the TeacherLoadRow interface.
 */
export function instanceOfTeacherLoadRow(value: object): value is TeacherLoadRow {
    if (!('teacherId' in value) || value['teacherId'] === undefined) return false;
    if (!('teacherName' in value) || value['teacherName'] === undefined) return false;
    if (!('classesCount' in value) || value['classesCount'] === undefined) return false;
    return true;
}

export function TeacherLoadRowFromJSON(json: any): TeacherLoadRow {
    return TeacherLoadRowFromJSONTyped(json, false);
}

export function TeacherLoadRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeacherLoadRow {
    if (json == null) {
        return json;
    }
    return {
        
        'teacherId': ApiUserTasksGetPageParameterFromJSON(json['teacherId']),
        'teacherName': json['teacherName'],
        'classesCount': ApiUserTasksGetPageParameterFromJSON(json['classesCount']),
    };
}

export function TeacherLoadRowToJSON(json: any): TeacherLoadRow {
    return TeacherLoadRowToJSONTyped(json, false);
}

export function TeacherLoadRowToJSONTyped(value?: TeacherLoadRow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'teacherId': ApiUserTasksGetPageParameterToJSON(value['teacherId']),
        'teacherName': value['teacherName'],
        'classesCount': ApiUserTasksGetPageParameterToJSON(value['classesCount']),
    };
}

